import { LiveData } from '@toeverything/infra';

export const FEATURE_KEY_COLLECTIONS = 'collections';
export const FEATURE_KEY_TAGS = 'tags';

export type StreamLainProductFeatureKey =
  | typeof FEATURE_KEY_COLLECTIONS
  | typeof FEATURE_KEY_TAGS;

type ProductFeatureGateState = Record<StreamLainProductFeatureKey, boolean>;

const disabledProductFeatures: ProductFeatureGateState = {
  [FEATURE_KEY_COLLECTIONS]: false,
  [FEATURE_KEY_TAGS]: false,
};

export const productFeatureGateState$ = new LiveData<ProductFeatureGateState>(
  disabledProductFeatures
);

export function setProductFeatureGateState(
  next: Partial<ProductFeatureGateState>
) {
  productFeatureGateState$.next({
    ...productFeatureGateState$.value,
    ...next,
  });
}

export function isProductFeatureAllowed(
  featureKey: StreamLainProductFeatureKey
) {
  return productFeatureGateState$.value[featureKey] === true;
}
